import { apiFetch } from '@lib/api/apiClient';

/**
 * 현재 로그인된 관리자 정보 조회
 * @returns {Promise<Object>} 관리자 정보
 */
export async function getAdmin() {
    const res = await apiFetch('/admin/me');
    console.log(res);
    if (!res.ok) {
        throw new Error('관리자 정보를 불러오지 못했습니다.');
    }
    return await res.json();
}